export const GET_CHANNEL_CONFIG = 'GET_CHANNEL_CONFIG';
export const CONFIG_CHANNEL_DATA_SUCCESSFULL = 'CONFIG_CHANNEL_DATA_SUCCESSFULL';
export const CONFIG_API_ERROR ="CONFIG_API_ERROR";
export const UPDATE_CHANNEL_CONFIG_DATA = "UPDATE_CHANNEL_CONFIG_DATA";
export const UPDATE_CHANNEL_CONFIG_DATA_SUCCESSFULL = "UPDATE_CHANNEL_CONFIG_DATA_SUCCESSFULL";
export const RESET_ALERT_CONFIG ="RESET_ALERT_CONFIG";